module.exports = __webpack_public_path__ + "static/6305-woodrose-16-961ec80e00a9f08ec4964d150dd95204.jpg";